import { Box, TextField, Typography } from "@mui/material";
import { useState, useEffect, SetStateAction, Dispatch } from "react";

type MultiEmailInputProps = {
    label?: string;
    value?: string;
    onChange?: (emails: string[]) => void;
    errors: string[];
    setErrors: Dispatch<SetStateAction<string[]>>
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const MultiEmailInput = ({
    label = "Correos",
    value = "",
    onChange,
    errors,
    setErrors
}: MultiEmailInputProps) => {

    const [inputValue, setInputValue] = useState(value);


    const validateEmails = (text: string) => {
        const list = text
            .split(",")
            .map(e => e.trim())
            .filter(e => e.length > 0);

        const invalid = list.filter(email => !emailRegex.test(email));

        setErrors(invalid);
        onChange && onChange(list);
    };

    useEffect(() => {
        validateEmails(inputValue);
    }, [inputValue]);

    return (
        <Box>
            <TextField
                fullWidth
                multiline
                rows={10}
                label={label}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
            />

            {errors.length > 0 && (
                <Typography color="error" sx={{ mt: 1, fontSize: '14px', maxHeight: "100px", overflowY: "auto", }}>
                    Correos inválidos: {errors.join(", ")}
                </Typography>
            )}
        </Box>
    );
};
